<div class="gallery-tabs-container">
  <div class="tab-container-wrapper" [ngClass]="{ 'min-gallery-height': isDrawerOpen && !presentationV3 }">
    @if (!presentationV3) {
      <div class="tabs-arrow-container">
        <button (click)="toggleDrawer()" [ngClass]="{ 'button-closed': !isDrawerOpen }">
          @if (isDrawerOpen) {
            <mat-icon alt="open drawer">expand_more</mat-icon>
          }
          @if (!isDrawerOpen) {
            <mat-icon alt="close drawer">expand_less</mat-icon>
          }
        </button>
      </div>
    }
    <div
      class="tabs-presentation-drawer"
      [ngClass]="{
        'presentation-drawer': presentationV3,
        'tabs-presentation-drawer': !presentationV3,
        open: isDrawerOpen,
        closed: !isDrawerOpen,
      }"
    >
      <presentation-gallery
        class="presentation-gallery"
        [isGalleryOpen]="isDrawerOpen"
        (galleryChange)="toggleDrawer()"
      ></presentation-gallery>
    </div>
  </div>
</div>
